// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    FindWarehouseData,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";

const XngFindWarehouseData: typeof FindWarehouseData = props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (props.apiResult && props.apiResult.inventoryWarehousesDtos) {
        const inventoryWarehousesDto =
            props.apiResult.inventoryWarehousesDtos.find(
                o => o.unitOfMeasure.toLowerCase() === props.parameter.unitOfMeasure.toLowerCase(),
            ) || props.apiResult.inventoryWarehousesDtos[0];

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            props.result = {
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
            };
        }
    }
};

replaceInChain(chain, FindWarehouseData, XngFindWarehouseData);
